import { render, staticRenderFns } from "./ImportOwnNumber.vue?vue&type=template&id=6a6901a2&scoped=true&"
import script from "./ImportOwnNumber.vue?vue&type=script&lang=js&"
export * from "./ImportOwnNumber.vue?vue&type=script&lang=js&"
import style0 from "./ImportOwnNumber.vue?vue&type=style&index=0&id=6a6901a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6901a2",
  null
  
)

export default component.exports